angular.module('octopusApp.tenants')
    .controller('DesignSelectedTagsController', function ($scope, $q, $uibModalInstance, $location, busy, octopusRepository, selectedValues, visibleTenantFilter, octopusTagSets, hideTenants) {
        var vm = this;
        vm.isLoading = busy.create();
        vm.selectedTenants = selectedValues.selectedTenants || [];
        vm.matchedTenantText = "0 tenants matched";
        vm.matchedTenants = [];
        vm.onlyShowMatching = true;
        vm.hideTenants = hideTenants;
        vm.close = $uibModalInstance.close;
        vm.save = save;
        vm.tenantFilter = tenantFilter;
        vm.tagsUpdated = tagsUpdated;
        var allTenants = [];


        function tagsUpdated() {
            var selectedTagList = vm.selectedTags;
            var allTagList = _.flatten(_.pluck(vm.tagSets, 'Tags'));

            return octopusRepository.Tenants.tagTest(vm.selectedTenants, selectedTagList).then(function (result) {

                var matchCount = 0;
                vm.matchedTenants = _.map(result, function (tenantTestResult, tenantId) {


                    var tenant = allTenants.filter(function (t) {
                        return t.Id === tenantId;
                    })[0];

                    var filterOverride = visibleTenantFilter(tenant);

                    if (!tenant) {
                        return null;
                    }

                    if (tenantTestResult.IsMatched && !filterOverride) {
                        matchCount++;
                    }

                    var matchedTags = _.intersection(selectedTagList, tenant.TenantTags);

                    return {
                        id: tenantId,
                        name: tenant.Name,
                        reason: filterOverride || tenantTestResult.Reason,
                        isMatched: tenantTestResult.IsMatched && !filterOverride,
                        isMatchedByName: vm.selectedTenants.indexOf(tenantId) !== -1 && !filterOverride,
                        missingTags: tenantTestResult.MissingTags,
                        matchedTags: allTagList.filter(function (tag) {
                            return matchedTags.indexOf(tag.CanonicalTagName) !== -1;
                        })
                    };
                })
                    .filter(function (tenant) {
                        return !!tenant;
                    })
                    .sort(function (resultA, resultB) {
                        if (resultA.isMatched && !resultB.isMatched) {
                            return -1;
                        } else if (!resultA.isMatched && resultB.isMatched) {
                            return 1;
                        }

                        if (resultA.name < resultB.name) {
                            return -1;
                        } else if (resultA.name > resultB.name) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });

                vm.matchedTenantText = matchCount + ' matching tenant' + (matchCount === 1 ? '' : 's');
            });
        }

        function tenantFilter(value) {
            return !vm.onlyShowMatching || (vm.onlyShowMatching && value.isMatched);
        }

        function save() {
            $uibModalInstance.close({
                selectedTenants: vm.selectedTenants,
                selectedTags: vm.selectedTags
            });
        }

        function init() {
            var loadingTagSets = vm.isLoading.promise(octopusTagSets.getAll().then(function (tagSets) {
                vm.tagSets = tagSets.filter(function (ts) {
                    return ts.Tags.length > 0;
                });
                vm.selectedTags = _.clone(selectedValues.selectedTags);
            }));

            var loadingTenants = vm.isLoading.promise(octopusRepository.Tenants.all().then(function (tenants) {
                allTenants = tenants;
                vm.availableTenants = allTenants.filter(function (tenant) {
                    return !visibleTenantFilter(tenant);
                });
            }));

            $q.all([loadingTagSets, loadingTenants]).then(function () {
                vm.tagsUpdated();
            });
        }

        init();
    });


//////////////////
// WEBPACK FOOTER
// ./app/areas/tenants/advanced_tenant_selector/design_selected_tags_controller.js
// module id = 621
// module chunks = 1